import { Select } from "antd";
import { IoMdCut } from "react-icons/io";
import {
  IoArrowBackOutline,
  IoArrowForward,
  IoDocumentText,
  IoDocumentTextOutline,
} from "react-icons/io5";
import { MdZoomIn, MdZoomOut } from "react-icons/md";
import img from "../../../asset/images/dummy-img.jpg";
import "./style.scss";

const PageHeader = (props: any) => {
  return (
    <div className="detailScreen-box1">
      <div className="detailScreen-header">
        <div className="detailScreen-headerBox">
          <div className="detailScreen-headerBox2">
            <div onClick={() => props?.clickArrow("remove")}>
              <IoArrowBackOutline color="white" size={25} />
            </div>
            <div className="detailScreen-box2">
              Page -
              <Select
                className="custom-select"
                placeholder={"Pages"}
                bordered={false}
                style={{ width: 80 }}
                defaultValue={props?.activeIndex}
                value={props?.activeIndex}
                onChange={(index) => props?.changeIndex(index)}
              >
                {props?.totalPage?.map((items: any, index: number) => {
                  return (
                    <Select.Option key={index} value={index}>
                      {index + 1}
                    </Select.Option>
                  );
                })}
              </Select>
              <span style={{ color: "white", padding: "4px" }}>
                {props?.activeIndex + 1} /{props?.totalPage?.length}
              </span>
            </div>

            <div onClick={() => props?.clickArrow("add")}>
              <IoArrowForward size={25} color="white" />
            </div>
          </div>
          <div
            className="detailScreen-btin2"
            style={{
              color: props?.activeZoom ? "#b72c6f)" : "#000",
            }}
            onClick={() => props?.setActiveZoom()}
          >
            {props?.activeZoom ? (
              <MdZoomOut size={25} color="white" />
            ) : (
              <MdZoomIn size={25} color="white" />
            )}
            <div className="detailScreen-txt2">Zoom</div>
          </div>
          <div
            className="detailScreen-btin2"
            style={{
              color: props?.cropActive ? "#b72c6f" : "#000",
              backgroundColor: props?.cropActive ? "#82053f" : "#b72c6f",
            }}
            onClick={() => props?.setCropActive(!props?.cropActive)}
          >
            <IoMdCut size={25} color="white" />
            <div className="detailScreen-txt2">Crop</div>
          </div>

          <div
            className="detailScreen-btin2"
            style={{
              color: props?.acitvePreview ? "#b72c6f" : "#000",
            }}
            onClick={() => props?.changePreview(!props?.acitvePreview)}
          >
            {props?.acitvePreview ? (
              <IoDocumentText size={25} color="white" />
            ) : (
              <IoDocumentTextOutline size={25} color="white" />
            )}
            <div className="detailScreen-txt2">
              {props?.acitvePreview ? "Hide" : "Show"} Pages
            </div>
          </div>
        </div>
      </div>
      {props?.acitvePreview ? (
        <div className="detailScreen-PreviewBox">
          {props?.totalPage?.length
            ? props?.totalPage?.map((item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="PreviewBox-item"
                    onClick={() => props?.changeIndex(index)}
                  >
                    <img
                      src={item?.imageUrl || img}
                      style={{ width: "100%" }}
                    />
                    <div
                      className={`PreviewBox-selected ${
                        props?.activeIndex === index ? "active" : ""
                      }`}
                    >
                      {index + 1}
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
    </div>
  );
};

export default PageHeader;
